import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PromptTypes } from 'generated/graphql-types';
import { ScheduleDetailFormValue } from '../schedule-details/models/schedule-detail-form';
import { ScheduleDetailSaveModel } from '../schedule-details/models/schedule-detail-save.model';
import { ModifyScheduleFormData } from '../schedule-register/models/modify-schedule-form-data';
import { ScheduleRegisterListItem } from '../schedule-register/models/schedule-register-results.model';
import { ModifyScheduleForm } from './models/modify-schedule.form';

@Component({
    selector: 'ndt-modify-schedule',
    templateUrl: './modify-schedule.component.html',
    standalone: false
})
export class ModifyScheduleComponent implements OnInit {
   form: UntypedFormGroup;

   schedule: ScheduleRegisterListItem;

   title: string;

   constructor(
      @Inject(MAT_DIALOG_DATA) public data: ModifyScheduleFormData,
      private dialogRef: MatDialogRef<ModifyScheduleComponent>,
      private fb: UntypedFormBuilder
   ) {
      this.title = data.title;
      this.schedule = data.schedule;
   }

   ngOnInit(): void {
      const form: ModifyScheduleForm = {
         name: this.fb.control(this.schedule ? this.schedule.name : null, [Validators.required]),
      };

      this.form = this.fb.group(form);
   }

   onSubmit(): void {
      if (this.form.valid) {
         const value: ScheduleDetailFormValue = this.form.value;
         const result: ScheduleDetailSaveModel = {
            accountId: this.schedule.accountId,
            closedExceptions: this.schedule.closedExceptions.map((closedException) => {
               return {
                  ...closedException,
                  closedExceptionId: 0,
                  isDeleted: false,
                  prompt: {
                     file: null,
                     isReusable: false,
                     name: null,
                     promptId: closedException.promptId ?? 0,
                     typeId: PromptTypes.ClosedException,
                  },
                  schedulesToCopyTo: [],
               };
            }),
            description: this.schedule.description ?? null,
            name: value.name,
            scheduleHours: this.schedule.scheduleDetails.map((scheduleDetail) => {
               return {
                  ...scheduleDetail,
                  isDeleted: false,
                  scheduleDetailId: 0,
               };
            }),
            scheduleId: 0,
         };
         this.dialogRef.close(result);
      }
   }

   onCloseClick(): void {
      this.dialogRef.close(null);
   }
}
